<template>
  <div>
    <div class="chosen-words">

      <div class="label closeable"
        v-for="(word, index) in wordList"
        :item="word"
        :key="index"
        @click="removeWord(index)"
        >{{ word }}
          <i class="fas fa-times-circle"
          ></i>
      </div><!--/.label -->

    </div><!--/.chosen-words-->

    <div class="button-wrap">
      <div class="btn"
        :to="{ name: 'results', query: {  crystals: wordList }}"
        large
        v-if="wordList.length>2"
        >Show me my crystal
      </div><!--/.btn-->
    </div><!--/.button-wrap-->

  </div>
</template>

<script>
export default {
  /* Child component registration */
  components: {},

  /* Properties */
  props: ["words"],
  /* Component's local data */

  data() {
    return {
      // wordList: this.words
      wordList: this.words
    };
  },
  /* Watchers */
  watch: {
    words: function() {
      this.wordList = this.words;
    }
  },

  /* Computed properties */
  computed: {},

  /* Component methods */
  methods: {
    removeWord: function(word) {
      this.wordList.splice(word, 1);
    }
  },

  /* Vue lifecycle hooks:
  Ref: https://vuejs.org/v2/guide/instance.html#Instance-Lifecycle-Hooks
 */
  created() {},
  mounted() {},
  updated() {},
  destroyed() {}
};
</script>

<style lang="scss">
  .chosen-words {
    display: flex;
    justify-content: center;
    padding: 1rem;
    min-height: 75px;

    .label {
      &.closeable {
        cursor: pointer;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        padding: .325rem 1rem;
        background: #89917c;
        color: #fff;
        border-radius: 25px;
        letter-spacing: .1rem;
        margin: 0 1rem;
        
        i {
          margin-left: .5rem;
          cursor: pointer;
        }
      }
    }
  }
  .button-wrap {
    display: flex;
    justify-content: center;
    padding-top: 2rem;

    .btn {
      padding: 15px 30px;
      width: auto;
      font-size: 22px;
      font-weight: 400;
      fill: #FFFFFF;
      color: #FFFFFF;
      background-color: #000000;
      border-radius: 0px 0px 0px 0px;
      box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.07);
    }
  }
</style>

